import React, { useState, useContext, useEffect } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { ItemContext } from "../../context/ItemContext";

const CheckboxGroupMultiple = ({
  options,
  priceOfItem,
  onTotalOptionChange,
  isEditMode,
  editOptions,
}) => {
  const { cart, totalPrice, totalOption, setTotalOption } =
    useContext(ItemContext);
  const [selectedValues, setSelectedValues] = useState([]);
  const [itemPrice, setItemPrice] = useState(Number(priceOfItem));

    useEffect(() => {
      if (isEditMode && editOptions) {
        // Extract option names from editOptions and set them as selected values
        const editOptionNames = editOptions
          .filter(opt => options.some(option => option.name === opt.name))
          .map(opt => opt.name);
  
        setSelectedValues(editOptionNames);
  
        // Notify parent that options are already selected (if any)
        if (editOptionNames.length > 0) {
        
        }
      }
    }, [isEditMode, editOptions, options]);

  const handleCheckboxChange = (value, optionObj) => {
    const isChecked = selectedValues.includes(value);
    const selectedOption = options.find((option) => option.name === value);

    if (!selectedOption) return;

    let newSelectedValues;
    if (isChecked) {
      // Deselecting an option
      newSelectedValues = selectedValues.filter((val) => val !== value);
      setTotalOption(totalOption - Number(selectedOption.price));
      // Call the onTotalOptionChange function to update options in parent component
      onTotalOptionChange(optionObj, false);
    } else {
      // Selecting an option
      newSelectedValues = [...selectedValues, value];
      setTotalOption(totalOption + Number(selectedOption.price));
      // Call the onTotalOptionChange function to update options in parent component
      onTotalOptionChange(optionObj, true);
    }
    // Uplifting the state
    setSelectedValues(newSelectedValues);
  };

  return (
    <FormGroup style={{ flexDirection: "row" }}>
      {options.map((option) => (
        <FormControlLabel
          style={{ color: "black" }}
          key={option.id}
          control={
            <Checkbox
              checked={selectedValues.includes(option.name)}
              onChange={() => handleCheckboxChange(option.name, option)}
            />
          }
          label={`${option.name} - $${option.price / 100}`}
        />
      ))}
    </FormGroup>
  );
};

export default CheckboxGroupMultiple;
